import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";

const ExpenseReceipt = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const expense = location.state?.expenseData;
  const details = expense?.ExpenseDetailsdata || [];
  const payments = expense?.PaymentDetailsData || [];

  if (!expense) {
    return (
      <div className="container-fluid">
        <div className="alert alert-warning mt-3">Expense details not found.</div>
        <button className="btn btn-danger" onClick={() => navigate("/admin/search-expense")}>
          Close
        </button>
      </div>
    );
  }

  return (
    <div className="container-fluid">
      <div className="card p-0">
        <div className="card-body">
          <h4 className="text-center fw-bold mb-3">EXPENSE RECEIPT</h4>
          <div className="row border rounded p-3 mb-3">
            <div className="col-md-3"><strong>Expense No:</strong> {expense.expense_no || "-"}</div>
            <div className="col-md-3"><strong>Date:</strong> {expense.date || "-"}</div>
            <div className="col-md-3"><strong>Party Name:</strong> {expense.party_name || "-"}</div>
            <div className="col-md-3"><strong>Reference:</strong> {expense.party_reference || "-"}</div>
          </div>

          <div className="table-responsive">
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>Sr No</th>
                  <th>Expense Category</th>
                  <th>Amount</th>
                  <th>Remarks</th>
                </tr>
              </thead>
              <tbody>
                {details.length > 0 ? details.map((detail, index) => (
                  <tr key={detail.expense_detail_id || index}>
                    <td>{index + 1}</td>
                    <td>{detail.expense_category_name || "-"}</td>
                    <td>{detail.amount ?? "-"}</td>
                    <td>{detail.remarks || "-"}</td>
                  </tr>
                )) : (
                  <tr><td colSpan="4" className="text-center">No expense details found.</td></tr>
                )}
              </tbody>
            </table>
          </div>

          <div className="row justify-content-end mb-3">
            <div className="col-md-3"><strong>Total:</strong> {expense.total_amount ?? "-"}</div>
            <div className="col-md-3"><strong>Paid:</strong> {expense.paid_amount ?? "-"}</div>
            <div className="col-md-3"><strong>Balance:</strong> {expense.balance_amount ?? "-"}</div>
          </div>

          {payments.length > 0 && (
            <div className="table-responsive mb-3">
              <table className="table table-bordered">
                <thead><tr><th>Payment Method</th><th>Amount</th><th>Bank</th><th>Account</th></tr></thead>
                <tbody>{payments.map((payment, index) => (
                  <tr key={payment.payment_detail_id || index}>
                    <td>{payment.payment_method || "-"}</td>
                    <td>{payment.applied_amount ?? "-"}</td>
                    <td>{payment.bank_name || "-"}</td>
                    <td>{payment.bank_account || "-"}</td>
                  </tr>
                ))}</tbody>
              </table>
            </div>
          )}

          <button type="button" className="btn btn-danger" onClick={() => navigate("/admin/search-expense")}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default ExpenseReceipt;
